import { useContext, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import jwt from 'jsonwebtoken'
import QRCode from 'react-qr-code'

import { useToast } from '../../hooks/toast'
import { getOrdersList } from '../../hooks/pedidos/usePedidos'
import * as auth from '../../api/auth/auth.js'
import {
  GetOrdersRequest,
  OrderProps,
  PixPagamentoProps,
  ProdutoProps,
  RemessasProps,
  StatusPedidoProps,
  TrackingProps
} from '../../types/pedidos'

import { dateFromString } from '../Filter/masks'
import { checkFormaPagamento } from './utils'
import {
  capitalizePhrase,
  convertDecimalCurrency,
  convertDecimalCurrencyTest,
  converterParaNumero
} from '../../utils/utils'
import {
  //changePedidoStatusToTag,
  getPedidoStatusColor
} from '../FichaPedido/utils'

import IconTrack from '../../assets/icons/icon-track.svg'
import CreditCardImage from '../MyPaymentCards/CreditCardImage'
import CardProduto from '../CardProduto'
import { Tag } from '../FichaPedido/styles'
import IconRefresh from '../../assets/img/icon-refresh.svg'
import IconNf from '../../assets/img/icon-nf.svg'
import StepsPedido from '../StepsPedido'
import MediaMatch from '../MediaMatch'
import Loader from '../Loader'
import * as S from './styles'
import { UserContext } from '../../contexts/UserContext'
import ModalReview from '../ModalReview'
import ModalReviewFeedback from '../ModalReviewFeedback'

const Pedido = () => {
  const [produtoAvaliar, setProdutoAvaliar] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showFeedbackModal, setShowFeedbackModal] = useState(false)
  const [feedbackMessage, setFeedbackMessage] = useState('')

  const abrirModal = (produto) => {
    setProdutoAvaliar(produto)
    setIsModalOpen(true)
  }

  const fecharModal = () => {
    setProdutoAvaliar(null)
    setIsModalOpen(false)
  }
  const params: any = useParams()
  const { addToast }: any = useToast()
  const history = useHistory()

  const token = `${auth.token()}`
  const tokendecoded = jwt.decode(token)
  const { tipoCliente, cpf, cnpj } = tokendecoded
  const [copy, setCopy] = useState(false)
  const { user } = useContext(UserContext)

  const { filterParams, setFilterParams } = useContext(UserContext)

  const { data, isLoading, refetch } = useQuery(
    [
      'pedidos',
      filterParams.IdStatus,
      filterParams.IdPedido,
      filterParams.DataInicial,
      filterParams.DataFinal,
      filterParams.Page,
      filterParams.PageSize
    ],
    () =>
      getOrdersList(
        filterParams.IdStatus,
        filterParams.IdPedido,
        filterParams.DataInicial,
        filterParams.DataFinal,
        filterParams.Page,
        filterParams.PageSize
      ),
    {
      onError: () => {
        addToast({
          type: 'error',
          title: 'Não foi possível realizar busca',
          description: `Verifique os campos e tente novamente`
        })
      },
      staleTime: 1000 * 60 // 1 minuto,
    }
  )

  const changePagamentoMessage = (pedido: OrderProps) => {
    const tipoPagamento = pedido?.Pagamento?.PagamentoTipo

    const descricaoPagamento = pedido?.Pagamento.PagamentoDescricao

    const juros = pedido?.Juros

    const quantidadeParcelas = pedido?.QuantidadeParcelas

    const valorParcela = pedido?.ValorParcela

    if (tipoPagamento === 'BOLETO' && descricaoPagamento === 'BOLETO_A_VISTA') {
      return (
        <>
          {pedido?.Pagamento?.Condicao} (
          <Link
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_URL_MAIN}/bradesco/gerarboleto/?idpedido=${pedido?.IdPedido}`
              )
            }}
            to={'#'}
          >
            2ª via aqui
          </Link>
          )
        </>
      )
    }

    if (descricaoPagamento === 'BOLETO_GIMBA_FATURADO') {
      if (juros === '0,00%') {
        return pedido?.Pagamento?.Condicao
      } else if (juros !== '0') {
        return `${pedido?.Pagamento?.Condicao} ${juros}`
      } else {
        return pedido?.Pagamento?.Condicao
      }
    }

    switch (tipoPagamento) {
      case 'CARTAO_DE_CREDITO':
        if (
          pedido.Pagamento?.Situacao === 'FALHA' &&
          pedido.StatusPedido !== 'PEDIDO_CANCELADO'
        ) {
          return (
            <>
              Não Aprovado (
              <Link to={`/dados-pagamento/${pedido.IdPedido}`}>Verificar</Link>)
            </>
          )
        } else if (
          pedido.Pagamento?.Situacao === 'FALHA' &&
          pedido.StatusPedido === 'PEDIDO_CANCELADO'
        ) {
          return <>Não Aprovado</>
        } else {
          return juros === ''
            ? `(Crédito) Em ${quantidadeParcelas}x de ${valorParcela} sem juros`
            : `(Crédito) Em ${quantidadeParcelas}x de ${valorParcela} com juros de ${juros}`
        }
      case 'PIX':
        if (pedido.Pagamento?.Situacao === 'EM_PROCESSAMENTO') {
          return 'Pix - Aguardando Pagamento'
        } else if (pedido.Pagamento?.Situacao !== 'FALHA') {
          return 'Pix - Pagamento confirmado'
        } else {
          return 'Pix'
        }
      default:
        return pedido.Pagamento.Condicao
    }
  }

  const checkNf = (trackingList: Array<TrackingProps>) => {
    return trackingList.find(
      (e) => e.DescricaoStatus === 'EMISSÃO DE NOTA FISCAL'
    )
  }

  // const checkDeliveryTracking = (remessa) => {
  //   return remessa.find((e) => e.DescricaoStatus === 'AGUARDANDO TRANSPORTE')
  // }

  const checkDeliveryLink = (remessa: RemessasProps) => {
    switch (remessa.SellerNome) {
      case 'Gimba':
        if (
          remessa.Envio?.CodigoRastreio &&
          remessa.Envio?.CodigoRastreio.length > 0
        ) {
          return true
        } else {
          return false
        }

      default:
        if (
          remessa.Envio?.RastreioUrl &&
          remessa.Envio?.RastreioUrl.length > 0
        ) {
          return true
        } else if (
          remessa.Envio?.RastreioUrl.length === 0 &&
          remessa.Envio?.Transportadora?.toLowerCase().includes('correios')
        ) {
          return true
        } else {
          return false
        }
    }
  }

  const checkEntregue = (trackingList: Array<TrackingProps>) => {
    return trackingList.find((e) => e.DescricaoStatus === 'PEDIDO ENTREGUE')
  }

  const getLastEl = (trackingList: Array<TrackingProps>) => {
    trackingList.sort((a, b) => a.Id - b.Id)

    const last = trackingList[trackingList?.length - 1]
    return last?.PedidoSituacao
  }

  const getLastElDate = (trackingList: Array<TrackingProps>) => {
    const last = trackingList[trackingList.length - 1]

    return last.DataHoraMovimentacao
  }

  const isCanceled = (status: StatusPedidoProps) => {
    if (status === 'PEDIDO_CANCELADO') {
      return true
    } else {
      return false
    }
  }

  const getCpfCnpj = () => {
    if (tipoCliente === 'F') {
      return cpf.trim()
    } else {
      return cnpj.trim()
    }
  }

  const copyToClipboard = (qrCodeValue: PixPagamentoProps) => {
    navigator.clipboard.writeText(qrCodeValue.QrCode)

    setCopy(true)
    setTimeout(() => {
      setCopy(false)
    }, 3000)
  }

  const getGimbaIndex = (pedido: OrderProps) => {
    const index = pedido.Remessas.findIndex((i) => i.SellerNome === 'Gimba')
    return index
  }

  const arraymove = (
    arr: Array<RemessasProps>,
    pedido: OrderProps,
    fromIndex: number,
    toIndex: number
  ) => {
    const found = pedido.Remessas.some((el) => el.SellerNome === 'Gimba')

    if (!!found) {
      var element = arr[fromIndex]
      arr.splice(fromIndex, 1)
      arr.splice(toIndex, 0, element)
    }
  }

  const filiais = (input: Array<ProdutoProps>) => {
    const ids = new Set()

    return input
      ?.map((e) => ({ filial: e.Filial, id: e.IdFilial }))
      .filter((e) => {
        if (ids.has(e.id)) {
          return false
        }

        ids.add(e.id)
        return true
      })
  }

  if (isLoading) return <Loader />

  const pedidoItem = data?.Data.filter(
    (pedido) => pedido.IdPedido === parseInt(params.idPedido)
  )

  return (
    <>
      {pedidoItem?.length === 0
        ? history.push('/meus-pedidos')
        : pedidoItem?.map((pedido) => {
            return (
              <S.Wrapper key={pedido.IdPedido}>
                {/* {pedido.Remessas.length === 0 && history.push('/meus-pedidos')} */}
                <S.DetailsHead>
                  <S.DetailsWrapper className="card">
                    <h3>Detalhes do Pedido</h3>

                    <p>
                      <strong>Pedido nº: </strong> {pedido?.IdPedido}
                    </p>
                    <p>
                      <strong>Realizado em: </strong> {pedido?.DataPedido} às{' '}
                      {pedido?.HoraPedido}
                    </p>

                    <p>
                      <strong>Produtos: </strong>
                      {convertDecimalCurrency(
                        converterParaNumero(pedido?.ValorTotalProdutos) -
                          (converterParaNumero(pedido?.ValorTotalIPI) || 0)
                      )}
                    </p>

                    {/* {pedido?.ValorDesconto === 'R$ 0,00' ? null : (
                      <p>
                        <strong>Descontos: </strong> {pedido?.ValorDesconto}
                      </p>
                    )} */}

                    {!pedido.PossuiIPI ? null : (
                      <p>
                        <strong>IPI: </strong> {pedido?.ValorTotalIPI}
                      </p>
                    )}

                    <p>
                      <strong>Frete: </strong>{' '}
                      {pedido?.ValorFrete === 'R$ 0,00'
                        ? 'Grátis'
                        : pedido?.ValorFrete}
                    </p>

                    {pedido?.AcrescimoFinanceiro === '' ||
                    pedido?.AcrescimoFinanceiro == null ||
                    pedido?.AcrescimoFinanceiro === 'R$ 0,00' ? null : (
                      <p>
                        <strong>Acréscimo Financeiro: </strong>{' '}
                        {pedido?.AcrescimoFinanceiro}
                      </p>
                    )}

                    {pedido?.ValorSubstituicaoTributaria === '' ||
                    pedido?.ValorSubstituicaoTributaria == null ||
                    pedido?.ValorSubstituicaoTributaria === 'R$ 0,00' ? null : (
                      <p>
                        <strong>ICMS-ST: </strong>{' '}
                        {pedido?.ValorSubstituicaoTributaria}
                      </p>
                    )}

                    {pedido?.ValorDescontoFormaPagamento === '' ||
                    pedido?.ValorDescontoFormaPagamento == null ||
                    pedido?.ValorDescontoFormaPagamento === 'R$ 0,00' ? null : (
                      <p>
                        <strong>Desconto Pagamento: </strong>{' '}
                        {/* {convertDecimalCurrency(pedido?.ValorDescontoFormaPagamento)} */}
                        {pedido?.ValorDescontoFormaPagamento}
                      </p>
                    )}

                    {pedido?.ValorDescontoGimplus === '' ||
                    pedido?.ValorDescontoGimplus == null ||
                    pedido?.ValorDescontoGimplus === 'R$ 0,00' ? null : (
                      <p>
                        <strong>Desconto Gimplus: </strong>{' '}
                        {pedido?.ValorDescontoGimplus}
                      </p>
                    )}

                    {pedido?.ValorCupomDesconto === '' ||
                    pedido?.ValorCupomDesconto == null ||
                    pedido?.ValorCupomDesconto === 'R$ 0,00' ? null : (
                      <p>
                        <strong>Cupom Desconto: </strong>{' '}
                        {pedido?.ValorCupomDesconto}
                      </p>
                    )}

                    <p>
                      <strong>Valor Total: </strong>
                      {pedido?.ValorTotalPedido}
                    </p>
                  </S.DetailsWrapper>

                  <S.AddressPaymentWrapper>
                    <S.AddressPaymentItem className="card">
                      <h3>Entrega</h3>

                      <strong>{pedido?.EnderecoEntrega?.Nome}</strong>

                      <p>
                        {capitalizePhrase(pedido?.EnderecoEntrega?.Endereco)},{' '}
                        {pedido?.EnderecoEntrega?.Numero} -{' '}
                        {capitalizePhrase(pedido?.EnderecoEntrega?.Bairro)} -{' '}
                        {capitalizePhrase(pedido?.EnderecoEntrega?.Cidade)}/
                        {pedido?.EnderecoEntrega?.Estado} -{' '}
                        {pedido?.EnderecoEntrega?.Cep.replace(
                          /^([\d]{2})*([\d]{3})-*([\d]{3})/,
                          '$1$2-$3'
                        )}
                      </p>
                    </S.AddressPaymentItem>

                    <S.AddressPaymentItem className="card">
                      <h3>Pagamento</h3>

                      <div className="pagamento">
                        <CreditCardImage
                          cartao={checkFormaPagamento(
                            pedido?.Pagamento.PagamentoDescricao
                          )}
                        ></CreditCardImage>
                        <p>{changePagamentoMessage(pedido)} </p>
                      </div>
                    </S.AddressPaymentItem>
                  </S.AddressPaymentWrapper>
                </S.DetailsHead>

                <MediaMatch lessThan="800px">
                  <a
                    href={`${process.env.REACT_APP_URL_MAIN}/pedidos/recompraV2?idpedido=${pedido?.IdPedido}`}
                  >
                    <S.Button>
                      <img src={IconRefresh} alt="Ícone refazer pedido" />
                      Refazer Pedido
                    </S.Button>
                  </a>
                </MediaMatch>

                {pedido.PixPagamento !== null &&
                pedido.Pagamento?.Situacao === 'EM_PROCESSAMENTO' ? (
                  <div className="pix">
                    <div className="qr-code">
                      {pedido.PixPagamento.QrCodeUrl !== '' ? (
                        <img
                          src={pedido.PixPagamento.QrCodeUrl}
                          alt=""
                          width={150}
                        />
                      ) : (
                        <img
                          src={
                            'data:image/png;base64,' +
                            pedido.PixPagamento.QrCodeImage
                          }
                          alt=""
                          width={150}
                        />
                      )}
                      {console.log(pedido.PixPagamento)}

                      <S.CopyPixCode
                        onClick={() => copyToClipboard(pedido.PixPagamento)}
                      >
                        Copiar código
                      </S.CopyPixCode>

                      <S.CopyTooltip className="copy-message" active={copy}>
                        Código copiado!
                      </S.CopyTooltip>
                    </div>
                    <ul>
                      <li>
                        <strong>1 - </strong>Abra o app ou banco da sua
                        preferência. Escolha a opção pagar com código PIX "
                        copia e cola", ou código QR.
                      </li>

                      <li>
                        <strong>2 - </strong>Copie e cole o código, ou escaneie
                        o código QR com a câmera do seu celular. Confira todas
                        as informações e autorize o pagamento.
                      </li>

                      <li>
                        <strong>3 - </strong>Você vai receber a confirmação do
                        pagamento em seu email. E pronto!
                      </li>

                      <li>
                        <strong>
                          O código é válido até{' '}
                          {pedido.PixPagamento?.DataVencimento?.replace(
                            ' ',
                            ' às '
                          )}
                        </strong>

                        <p>
                          Se o pagamento não for confirmado até a validade
                          acima, o pedido será cancelado automaticamente.
                        </p>
                      </li>
                    </ul>
                  </div>
                ) : null}

                {/* Exibir Remessa Gimba primeiro  */}
                {arraymove(pedido.Remessas, pedido, getGimbaIndex(pedido), 0)}

                {pedido?.Remessas.map((seller, index) => {
                  return (
                    <S.Delivery className="card" key={seller.SellerId}>
                      <div className="pedido-head">
                        <p>
                          <strong>
                            Entrega {index + 1} de {pedido.Remessas.length}
                          </strong>{' '}
                          - Entregue por {seller.SellerNome}
                        </p>

                        {/* <div className="tag-status">
                          {checkEntregue(seller.Tracking) !== undefined ? (
                            <>
                              <Tag
                                color={getPedidoStatusColor(
                                  getLastEl(seller.Tracking)
                                )}
                              >
                                {changePedidoStatusToTag(
                                  getLastEl(seller.Tracking)
                                )}
                              </Tag>
                              <p className="data-entrega">
                                Entregue em:{' '}
                                <strong>
                                  {dateFromString(
                                    getLastElDate(seller.Tracking)
                                  )}
                                </strong>
                              </p>
                            </>
                          ) : (
                            <Tag
                              color={getPedidoStatusColor(
                                getLastEl(seller.Tracking)
                              )}
                            >
                              {changePedidoStatusToTag(
                                getLastEl(seller.Tracking)
                              )}
                            </Tag>
                          )}
                        </div> */}
                      </div>
                      {/* {getTracking(seller.Tracking)} */}

                      <StepsPedido
                        tracking={seller.Tracking}
                        seller={seller}
                        pedido={pedido}
                        isCanceled={isCanceled(pedido.StatusPedido)}
                        documento={getCpfCnpj()}
                        delivery={checkDeliveryLink(seller)}
                      ></StepsPedido>
                      <hr />

                      <div className="nota-fiscal">
                        {checkDeliveryLink(seller) ? (
                          <S.ButtonPedidos
                            onClick={() => {
                              const validateUrl = /https?:\/\//g
                              const regex = new RegExp(validateUrl)

                              if (seller.SellerNome === 'Gimba') {
                                window.open(
                                  `https://rastreamento.correios.com.br/app/index.php?objetos=${seller.Envio.CodigoRastreio}`
                                )
                              } else if (
                                seller.Envio.RastreioUrl.match(regex)
                              ) {
                                window.open(seller.Envio.RastreioUrl)
                              } else if (
                                seller.Envio.Transportadora.toLowerCase().includes(
                                  'correios'
                                )
                              ) {
                                window.open(
                                  `https://rastreamento.correios.com.br/app/index.php?objetos=${seller.Envio.CodigoRastreio}`
                                )
                              } else {
                                window.open(`//${seller.Envio.RastreioUrl}`)
                                // window.open(seller.Envio.RastreioUrl, '_blank')
                              }
                            }}
                          >
                            <img src={IconTrack} alt="Acompanhar Entrega" />
                            Acompanhar Entrega
                          </S.ButtonPedidos>
                        ) : null}
                        {checkNf(seller.Tracking) !== undefined ||
                        //(pedido.StatusPedido === 'EMISSAO_DE_NOTA_FISCAL' &&
                        (seller.NumeroNotaFiscal != null &&
                          seller.NumeroNotaFiscal != 0) ? (
                          <S.ButtonPedidos
                            className="outline-green"
                            onClick={() => {
                              if (seller.SellerNome === 'Gimba') {
                                window.open(
                                  `https://notasfiscais.gimba.com.br/notasfiscais.asp?nota=${
                                    seller?.NumeroNotaFiscal
                                  }&cpfcnpj=${getCpfCnpj()}&tipo=pdf`
                                )
                              } else {
                                if (
                                  seller?.NotaFiscal?.LinkDANFE === '' ||
                                  seller?.NotaFiscal?.LinkDANFE === null
                                ) {
                                  window.open(
                                    `https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ+gAVw2g=&nfe=${seller?.NotaFiscal?.Chave}`
                                  )
                                } else {
                                  window.open(
                                    `${seller?.NotaFiscal?.LinkDANFE}`
                                  )
                                }
                              }
                            }}
                          >
                            <img
                              src={IconNf}
                              alt="Ícone visualizar Nota Fiscal"
                            />
                            Ver Nota Fiscal
                          </S.ButtonPedidos>
                        ) : null}
                      </div>
                      <strong>Itens do Pedido</strong>
                      {seller.SellerNome === 'Gimba' ? (
                        filiais(seller.Itens)?.map((filial) => {
                          return (
                            <>
                              <div className="filiais">
                                Produtos serão entregues por{' '}
                                <strong>{filial.filial}</strong>
                              </div>

                              <div className="produtos">
                                {seller.Itens?.filter(
                                  (item) => item.Filial === filial.filial
                                )?.map((item) => {
                                  return (
                                    <CardProduto
                                      key={item.IdProduto}
                                      data={{
                                        id: item.IdProduto,
                                        idMedia: item.IdObjetoMedia,
                                        name: item.DescricaoResumida,
                                        seller: seller.SellerNome,
                                        preco: item.ValorTotal,
                                        quantidade: item.Quantidade,
                                        ValorIPI: item.ValorIPI,
                                        PossuiIPI: item.PossuiIPI,
                                        PercentualIPI: item.PercentualIPI,
                                        JaComprou: item.JaComprou,
                                        Avaliado: item.Avaliado
                                      }}
                                      agenda={undefined}
                                      check={undefined}
                                      setCheck={undefined}
                                      onAvaliar={() => abrirModal(item)}
                                    ></CardProduto>
                                  )
                                })}
                              </div>
                            </>
                          )
                        })
                      ) : (
                        <div className="produtos">
                          {seller.Itens.map((item) => {
                            return (
                              <CardProduto
                                key={item.IdProduto}
                                data={{
                                  id: item.IdProduto,
                                  idMedia: item.IdObjetoMedia,
                                  name: item.DescricaoResumida,
                                  seller: seller.SellerNome,
                                  preco: item.ValorTotal,
                                  quantidade: item.Quantidade,
                                  ValorIPI: item.ValorIPI,
                                  PossuiIPI: item.PossuiIPI,
                                  JaComprou: item.JaComprou,
                                  Avaliado: item.Avaliado
                                }}
                                agenda={undefined}
                                check={undefined}
                                setCheck={undefined}
                                onAvaliar={() => abrirModal(item)}
                              />
                            )
                          })}
                        </div>
                      )}
                    </S.Delivery>
                  )
                })}

                <S.DetailsFooter>
                  <MediaMatch greaterThan="801px">
                    <a
                      href={`${process.env.REACT_APP_URL_MAIN}/pedidos/recompraV2?idpedido=${pedido?.IdPedido}`}
                    >
                      <S.Button>
                        <img src={IconRefresh} alt="Ícone refazer pedido" />
                        Refazer Pedido
                      </S.Button>
                    </a>
                  </MediaMatch>

                  <Link to="/meus-pedidos" className="voltar">
                    <S.Button className="outline">Voltar</S.Button>
                  </Link>
                </S.DetailsFooter>

                <ModalReview
                  isOpen={isModalOpen}
                  onClose={fecharModal}
                  produto={produtoAvaliar}
                  userID={user}
                  idPedido={pedido.IdPedido}
                  refetchPedidos={refetch}
                  onSuccessFeedback={() => setShowFeedbackModal(true)}
                  setFeedbackMessage={setFeedbackMessage}
                  avaliacao={data}
                />

                <ModalReviewFeedback
                  isOpen={showFeedbackModal}
                  onClose={() => setShowFeedbackModal(false)}
                  title="Atenção"
                  message={feedbackMessage}
                />
              </S.Wrapper>
            )
          })}
    </>
  )
}

export default Pedido
